import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: "text",
      ref: "input",
      value: _ctx.filledValue,
      class: _normalizeClass(["form-control", {'is-invalid': _ctx.isInvalid()}]),
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
    }, null, 42, _hoisted_1),
    (_ctx.isInvalid())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.filledValue === '')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('form.errors.parameterNotFilled', [_ctx.label])), 1)
              ], 64))
            : (_ctx.getValue() === null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.errors.invalidDate')), 1)
                ], 64))
              : (_ctx.isBeforeMinimum())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('form.errors.dateBeforeMinimum', [_ctx.label, _ctx.formatBound(_ctx.min)])), 1)
                  ], 64))
                : (_ctx.isAfterMaximum())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('form.errors.dateAfterMaximum', [_ctx.label, _ctx.formatBound(_ctx.max)])), 1)
                    ], 64))
                  : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}